import React from "react";

// Matches http(s)://… and bare www.… URLs. Anchored on whitespace boundaries to
// keep things permissive without grabbing surrounding punctuation as part of the
// host. Trailing punctuation is trimmed below.
const URL_REGEX = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
const TRAIL_PUNCT_REGEX = /[.,!?;:)\]'"]+$/;

/**
 * linkify — turn plain text into an array of React nodes, with URLs wrapped
 * in target=_blank anchors. Trailing punctuation (".", ",", ")", etc.) is
 * preserved as plain text so links don't swallow sentence punctuation.
 *
 * Usage:  {linkify("check https://spotify.com out.", { className: "..." })}
 */
export default function linkify(text, options = {}) {
  if (!text || typeof text !== "string") return text;
  const className =
    options.className ||
    "underline decoration-current/40 hover:decoration-current break-words";

  const out = [];
  let lastIndex = 0;
  let key = 0;
  let match;
  URL_REGEX.lastIndex = 0;
  while ((match = URL_REGEX.exec(text)) !== null) {
    const start = match.index;
    const raw = match[0];
    if (start > lastIndex) {
      out.push(text.slice(lastIndex, start));
    }
    let trimmed = raw;
    let trail = "";
    const trailMatch = trimmed.match(TRAIL_PUNCT_REGEX);
    if (trailMatch) {
      trail = trailMatch[0];
      trimmed = trimmed.slice(0, -trail.length);
    }
    const href = trimmed.startsWith("http") ? trimmed : `https://${trimmed}`;
    out.push(
      <a
        key={`lnk-${key++}-${start}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={(e) => e.stopPropagation()}
      >
        {trimmed}
      </a>,
    );
    if (trail) out.push(trail);
    lastIndex = start + raw.length;
  }
  if (lastIndex < text.length) out.push(text.slice(lastIndex));
  return out.length > 0 ? out : text;
}
